<div class="block-header">
  <div class="row">
    <div class="col-lg-5 col-md-8 col-sm-12">
      <h2>
        <a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth" (click)="handleFullWidth()">
          <i class="fa fa-arrow-left" id="fullWithToggler"></i>
        </a>
        {{pageTitle}}</h2>
      <ul class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/' + userRole +'/dashboard']" ><i class="icon-home"></i></a></li>
        <!--<li class="breadcrumb-item"><a [routerLink]="['/' + userRole +'/dashboard']" >Home</a></li>-->
        <li class="breadcrumb-item" *ngIf="dataInput.parent !== 'Home'">{{ dataInput.parent }}</li>

        <li class="breadcrumb-item active">{{pageTitle}}</li>
      </ul>
    </div>
    <div class="col-lg-7 col-md-4 col-sm-12 text-right">

    </div>
  </div>
</div>
